import { TableCell, TableRow } from 'ia-react-core';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledTableRow = styled(TableRow) <{ unread: boolean }>`
border-bottom: 1px solid ${({ theme }) => theme?.colors.gray4};
outline: none;
padding-right: 16px;

&:focus {
  background-color: ${({ theme }) => theme.colors.blue14};
}
${({ unread, theme }) => unread && `
background-color: ${theme.colors.blue12};
font-weight: bold;
`}

&:hover {
  background-color: ${({ theme }) => theme.colors.blue12};
  ${({ unread, theme }) => unread && `
    background-color: ${theme.colors.blue14};
  `}
}

&:active {
  background-color:  ${({ theme }) => theme.colors.blue14};
  ${({ unread, theme }) => unread && `
    background-color: ${theme.colors.blue15};
  `}
}
`;

export const StyledLink = styled(Link)`
  display: flex;
  flex: 1;
  color: ${({ theme }) => theme?.colors.text};
  text-decoration : none;
  padding : 0px;
`;

export const StyledMessagesTableCellWithoutText = styled(TableCell)`
  max-width: 30px;
  text-align: center !important;
  vertical-align: middle !important;
  padding-top: 14px;
  padding-bottom : 15px;
  height: 18px;  
`;

export const StyledTableCellIcon = styled(TableCell)`
  max-width: 20px;
  text-align: center !important;
  vertical-align: middle !important;
  padding-top: 12px;
  padding-bottom : 15px;
  height: 18px;
  
  &:empty {
    :before {
      content: '';
    }
  }
`;

export const StyledTableCellLeft = styled(TableCell)`
  text-align: left !important;
  padding-top: 0px;
  padding-bottom : 0px;
  padding-right: 0;
  max-width: 410px;  
  cursor:pointer;
`;

export const StyledMessageValue = styled.p`
  padding-bottom : 15px;
  padding-top : 15px;
  margin : 0px;
`;

export const StyledTableCellRight = styled(TableCell)`
  text-align: right !important;
  padding-top: 0px;
  padding-bottom : 0px;
  max-width: 200px;  
  padding-right: 0;
  cursor:pointer;
  `;
